import { __decorate } from "tslib";
import { html, nothing } from 'lit';
import { CipublicElement } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/base.js';
import { property, state, query, queryAssignedNodes } from 'lit/decorators.js';
import { addStyleSheetToElements } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/cssstylesheet-interface.js';
import { InternalI18n } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/i18n/internal-i18n-controller.js';
import { debounce } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/debounce.js';
import { gridBreakpoints, gridColumnGap } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/breakpoints.js';
import heroMediaStyles from './media.scss.js';
import styles from './hero.scss.js';
export class Hero extends CipublicElement {
    constructor() {
        super(...arguments);
        this.variant = 'text-hero';
        this.background = 'secondary';
        this.fullWidth = false;
        this.layout = '8-4';
        this.i18n = new InternalI18n(this);
    }
    get isMobile() {
        return !window.matchMedia(`(min-width: ${gridBreakpoints.md}px)`).matches;
    }
    get heroGreeting() {
        if (this.variant === 'big-media-hero') {
            const currentDay = new Date();
            const currentHour = currentDay.getHours();
            switch (true) {
                case currentHour >= 4 && currentHour < 12:
                    return {
                        message: this.i18n.t('goodMorning'),
                        icon: 'sun',
                    };
                case currentHour >= 12 && currentHour < 18:
                    return {
                        message: this.i18n.t('goodAfternoon'),
                        icon: 'sun',
                    };
                default:
                    return {
                        message: this.i18n.t('goodEvening'),
                        icon: 'moon',
                    };
            }
        }
        return;
    }
    async firstUpdated(changedProperties) {
        super.firstUpdated(changedProperties);
        await this.updateComplete;
        //@ts-ignore next-line
        window.addEventListener('resize', () => debounce(this.requestUpdate(), 250));
        window.addEventListener('load', this.setHeroAnimation.bind(this));
    }
    async updated(changedProperties) {
        super.updated(changedProperties);
        await this.updateComplete;
        this.setHeroAnimation();
        this.setImageWidth();
    }
    setImageWidth() {
        var _a;
        if (this.variant === 'split-media-hero') {
            const distanceToScreen = (_a = this.splitHeroImageHolder) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().left;
            this.splitHeroImage.forEach((image) => (image.style.width = this.isMobile ? '100%' : `calc(${distanceToScreen}px - ${gridColumnGap}px)`));
        }
    }
    // Document ready state due to the nature of Storybook, SPA.
    setHeroAnimation() {
        if (!this.isMobile && document.readyState === 'complete') {
            this.setImageWidth();
            this.setAttribute('isAnimated', 'true');
        }
        if (this.stickyBannerSlot && this.stickyBannerSlot.length) {
            this.mainHeroWrapper.classList.add('sticky-hero-padding');
        }
    }
    static get styles() {
        return [styles];
    }
    renderMedia() {
        return html `<slot name="media" @slotchange="${(event) => {
            addStyleSheetToElements(event.target.assignedElements(), heroMediaStyles);
        }}"></slot>`;
    }
    render() {
        var _a, _b;
        return html `<div class="main-wrapper"><div class="container"><div class="text-hero-spacer"></div><div class="content"><section class="heading-wrapper"><div class="meta-line"><span class="greeting">${(_a = this.heroGreeting) === null || _a === void 0 ? void 0 : _a.message}<cipublic-icon class="greeting-icon" fill="currentColor" .name="${(_b = this.heroGreeting) === null || _b === void 0 ? void 0 : _b.icon}" set="default"></cipublic-icon></span>${this.variant === 'big-media-hero' ? html `<span class="meta-link"><slot name="meta"></slot></span>` : nothing}</div>${this.variant !== 'big-media-hero' ? html `<slot name="meta"></slot>` : nothing}<slot name="heading"></slot></section><div><slot></slot></div></div>${this.variant === 'split-media-hero' ? this.renderMedia() : nothing}</div>${this.variant === 'big-media-hero' ? this.renderMedia() : nothing}</div><slot name="sticky-banner-hero"></slot><slot name="sticky-anchor-hero"></slot>`;
    }
}
__decorate([
    state()
], Hero.prototype, "isMobile", null);
__decorate([
    property({ reflect: true })
], Hero.prototype, "variant", void 0);
__decorate([
    property({ reflect: true })
], Hero.prototype, "background", void 0);
__decorate([
    query('[name="media"]')
], Hero.prototype, "splitHeroImageHolder", void 0);
__decorate([
    query('.main-wrapper')
], Hero.prototype, "mainHeroWrapper", void 0);
__decorate([
    property({ type: Boolean })
], Hero.prototype, "fullWidth", void 0);
__decorate([
    queryAssignedNodes('media', true)
], Hero.prototype, "splitHeroImage", void 0);
__decorate([
    queryAssignedNodes('sticky-banner-hero', true)
], Hero.prototype, "stickyBannerSlot", void 0);
__decorate([
    property()
], Hero.prototype, "imagePosition", void 0);
__decorate([
    property({ reflect: true })
], Hero.prototype, "layout", void 0);
__decorate([
    state()
], Hero.prototype, "heroGreeting", null);
//# sourceMappingURL=hero.js.map